<form [formGroup]="cseMaterialListForm">
    <fieldset formArrayName="formChildren">
        <ng-container>
            <div class="row mb-3 d-sm-flex d-none">
                <div class="col-6">
                    <label class="fw-bold" translate="MATERIAL_QUOTE_LABEL_MATERIAL_NUMBER"></label>
                </div>
                <div class="col-5">
                    <label class="fw-bold" translate="MATERIAL_QUOTE_LABEL_MATERIAL_QUANTITY"></label>
                </div>
            </div>
            @for (material of model.value; track material; let index = $index) {
                <div class="row mb-sm-3">
                    <div class="col-sm-6">
                        <div class="d-sm-none d-flex">
                            <label class="fw-bold" translate="MATERIAL_QUOTE_LABEL_MATERIAL_NUMBER"></label>
                        </div>
                        <pace-core-text-input
                            id="material{{ index }}"
                            [parentForm]="formChildren"
                            [(model)]="material.material"
                            [ariaLabel]="'MATERIAL_QUOTE_LABEL_MATERIAL_NUMBER' | translate"
                        ></pace-core-text-input>
                    </div>
                    <div class="col-10 col-sm-5">
                        <div class="d-sm-none d-flex">
                            <label class="fw-bold mt-1" translate="MATERIAL_QUOTE_LABEL_MATERIAL_QUANTITY"></label>
                        </div>
                        <pace-core-number-input
                            id="quantity{{ index }}"
                            [parentForm]="formChildren"
                            [(model)]="material.quantity"
                            [ariaLabel]="'MATERIAL_QUOTE_LABEL_MATERIAL_NUMBER' | translate"
                        ></pace-core-number-input>
                    </div>
                    <div
                        class="col-2 col-sm-1 d-flex justify-content-center justify-content-sm-start align-items-end flex-column"
                    >
                        @if (material.isDeletable) {
                            <button class="btn btn-warning float-end" (click)="deleteMaterial(index)">
                                <fa-icon [icon]="faTrashAlt" class="fa-xs"></fa-icon>
                            </button>
                        }
                    </div>
                    <hr class="d-sm-none d-flex separator mt-3" />
                </div>
            }
        </ng-container>
        <button class="btn btn-primary float-end" (click)="addMaterial()" translate="MATERIAL_ADD"></button>
    </fieldset>
</form>
